import { render } from "./ViewsDetailsView.vue?vue&type=template&id=c4516396&scoped=true"
import script from "./ViewsDetailsView.vue?vue&type=script&lang=js"
export * from "./ViewsDetailsView.vue?vue&type=script&lang=js"

import "./ViewsDetailsView.vue?vue&type=style&index=0&id=c4516396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4516396"]])

export default __exports__